module.exports = __webpack_public_path__ + "img/real.d77c03ac.png";